import useAuthInitialStates from "./auth";
import useToolsInitialStates from "./tools";
import useUserInitialStates from "./users";
import useRoleInitialStates from "./roles";
import useProjectIntialstate from "./projects";

const useInitialStates = () => {
  return {
    useAuthInitialStates,
    useToolsInitialStates,
    useUserInitialStates,
    useRoleInitialStates,
    useProjectIntialstate,
  };
};

export default useInitialStates;
